import { gql } from '@apollo/client';
export const USER_FIELDS = gql `
  fragment UserFields on User {
    id
    clientId
    firstName
    lastName
    email
    uniqueId
    phone
    mfasEnabled
    isActive
    isVerified
    isSuperuser
    roleNames
    disableAt
    productAccessSyncStatus
    productAccessSyncedAt
  }
`;
export const USERS = gql `
  ${USER_FIELDS}
  query USERS($spec: UserSpec!) {
    users(spec: $spec) {
      total
      page
      pageSize
      items {
        ...UserFields
      }
    }
  }
`;
export const CURRENT_USER = gql `
  query CURRENT_USER {
    currentUser {
      id
      employeeId
      uniqueId
      guildUserUuid
      clientId
      firstName
      lastName
      email
      phone
      mfasEnabled
      isActive
      isVerified
      isSuperuser
      permissions
      roleNames
      clientInfo {
        name
        currency
        locale
        timezone
        country
        guildEmployerUuid
      }
    }
  }
`;
export const VERIFY_CONFIRMATION_CODE = gql `
  query VERIFY_CONFIRMATION_CODE($email: String!, $confirmationCode: String!) {
    verifyConfirmationCode(email: $email, confirmationCode: $confirmationCode)
  }
`;
export const CREATE_USER = gql `
  ${USER_FIELDS}
  mutation CREATE_USER($input: CreateUserInput!) {
    createUser(input: $input) {
      __typename
      ... on User {
        ...UserFields
      }
      ... on UserSaveError {
        error
      }
      ... on ValidationErrors {
        validationErrors
      }
    }
  }
`;
export const UPDATE_USER = gql `
  ${USER_FIELDS}
  mutation UPDATE_USER($input: UpdateUserInput!) {
    updateUser(input: $input) {
      __typename
      ... on User {
        ...UserFields
      }
      ... on UserSaveError {
        error
      }
      ... on ValidationErrors {
        validationErrors
      }
    }
  }
`;
export const UPDATE_PROFILE = gql `
  ${USER_FIELDS}
  mutation UPDATE_PROFILE($input: UpdateUserInput!) {
    updateProfile(input: $input) {
      __typename
      ... on User {
        ...UserFields
      }
      ... on UserSaveError {
        error
      }
      ... on ValidationErrors {
        validationErrors
      }
    }
  }
`;
export const FORGOT_PASSWORD = gql `
  mutation FORGOT_PASSWORD($email: String!) {
    forgotPassword(email: $email) {
      __typename
      ... on ForgotResetPasswordResponse {
        type
        message
      }
    }
  }
`;
export const RESET_LOGIN_TOKEN = gql `
  mutation RESET_LOGIN_TOKEN($employeeId: Int!) {
    resetLoginToken(employeeId: $employeeId) {
      __typename
      ... on ResetLoginTokenResponse {
        isSuccess
        message
        token
        tokenExpiresAt
      }
    }
  }
`;
export const RESET_PASSWORD = gql `
  mutation RESET_PASSWORD($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      __typename
      ... on ForgotResetPasswordResponse {
        type
        message
      }
      ... on ValidationErrors {
        validationErrors
      }
    }
  }
`;
export const SIGN_UP = gql `
  mutation SIGN_UP($email: String!) {
    signUp(email: $email) {
      success
      message
    }
  }
`;
export const GET_USER = gql `
  ${USER_FIELDS}
  query GET_USER($spec: GetUserSpec!) {
    getUser(spec: $spec) {
      ...UserFields
    }
  }
`;
